import styled from "styled-components";

export const Results = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
  height: calc(100vh - 12rem);
  padding: 2rem;
`;

export const Grid = styled.div`
  margin: -1rem;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;

  ${({ theme }) => theme.media.sm`
    flex-direction: column;
  `}
`;

export const Cell = styled.div`
  width: 50%;
  padding: 1rem;

  ${({ theme }) => theme.media.lg`
    width: 100%;
  `}
`;
